import {
  FETCH_ROTATIVE_INVENTORY_REQUEST,
  FETCH_ROTATIVE_INVENTORY_SUCCESS,
  FETCH_ROTATIVE_INVENTORY_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: [],
  error: null,
  isFetching: false,
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_ROTATIVE_INVENTORY_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_ROTATIVE_INVENTORY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        records: action.payload,
      }

    case FETCH_ROTATIVE_INVENTORY_ERROR:
      return {
        ...state,
        isFetching: false,
        records: [],
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
